import { apiSlice } from '@/features/api/apiSlice';

export type Branding = {
  logoUrl: string | null;
  faviconUrl: string | null;
  customDomain: string | null;
  colors: Record<string, string>;
  fonts: Record<string, string>;
};

export type AutoDetectedBrand = {
  domain: string;
  logoUrl: string | null;
  primaryColor: string | null;
  source: 'theme-color' | 'fallback' | 'partial';
};

export const brandingApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    getBranding: b.query<Branding, void>({
      query: () => '/branding',
    }),
    updateBranding: b.mutation<Branding, Partial<Branding>>({
      query: (body) => ({ url: '/branding', method: 'PUT', body }),
    }),
    autoDetectBranding: b.query<AutoDetectedBrand, string>({
      query: (url) => `/branding/auto-detect?url=${encodeURIComponent(url)}`,
    }),
  }),
});

export const {
  useGetBrandingQuery,
  useUpdateBrandingMutation,
  useLazyAutoDetectBrandingQuery,
} = brandingApi;
